/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Připojení`
};

const da_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Connectivité`
};

const de_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Hardware-Verbindung`
};

const en_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Connectivité`
};

const es_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `conectividad de hardware`
};

const fr_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Connectivité`
};

const hu_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Connectivité`
};

const it_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Connettività hardware`
};

const nl_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Hardwareverbinding`
};

const pl_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Łączność sprzętowa`
};

const pt_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Conectividade de hardware`
};

const sv_attributes_hardware_connectivity = /** @type {(inputs: {}) => string} */ () => {
	return `Anslutningsmöjligheter för hårdvara`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_hardware_connectivity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_hardware_connectivity(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_hardware_connectivity", locale)
	if (locale === "cs") return cs_attributes_hardware_connectivity(inputs)
	if (locale === "da") return da_attributes_hardware_connectivity(inputs)
	if (locale === "de") return de_attributes_hardware_connectivity(inputs)
	if (locale === "en") return en_attributes_hardware_connectivity(inputs)
	if (locale === "es") return es_attributes_hardware_connectivity(inputs)
	if (locale === "fr") return fr_attributes_hardware_connectivity(inputs)
	if (locale === "hu") return hu_attributes_hardware_connectivity(inputs)
	if (locale === "it") return it_attributes_hardware_connectivity(inputs)
	if (locale === "nl") return nl_attributes_hardware_connectivity(inputs)
	if (locale === "pl") return pl_attributes_hardware_connectivity(inputs)
	if (locale === "pt") return pt_attributes_hardware_connectivity(inputs)
	return sv_attributes_hardware_connectivity(inputs)
};
export { attributes_hardware_connectivity as "attributes.hardware_connectivity" }